<template>
  <div class="eprights-cont">
    <div class="left-tabs">
      <a @click="gotoAid">法援申请</a>
      <a class="active" @click="gotoHistory">历史援助</a>
    </div>
    <div class="right-laws">
      <h3 class="titleh3">历史援助</h3>
      <div class="table-box">
        <a-table
          :columns="columns"
          :data-source="tableList"
          bordered
          :customRow="gotoAidDetail"
          :rowKey="(tableList) => tableList.pkid"
        >
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getHistoryAidList } from '@/api/aid';
const columns = [
  {
    title: '办件编号',
    dataIndex: 'serial_number',
    key: 'serial_number',
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '处理情况',
    dataIndex: 'trans_status_name',
    key: 'trans_status_name',
  },
  {
    title: '提交时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    title: '提交对象',
    dataIndex: 'accept_unit',
    key: 'accept_unit',
  },
];
const tableList = [];
export default {
  name: 'HistoryAid',
  data() {
    return {
      tableList,
      columns,
    };
  },
  mounted() {
    this.getHistoryAidList();
  },
  methods: {
    getHistoryAidList() {
      let category = this.$store.state.category;
      getHistoryAidList().then((res) => {
        console.log(res);
        let r = res.items;
        r.forEach(function (item, index) {
          item.trans_status_name = category.TransStatus[item.trans_status];
        });
        this.tableList = r;
      });
    },
    // gotoApply: function () {
    //   this.$router.push({ name: 'ApplicationGuide' });
    // },
    gotoAid() {
      this.$router.push({ name: 'ApplicationGuide' });
    },
    gotoHistory: function () {
      this.$router.push({ name: 'HistoryAid' });
    },
    gotoAidDetail(record, index) {
      return {
        on: {
          click: () => {
            let routeUrl = this.$router.resolve({
              name: 'LegalAid',
              query: { id: record.pkid },
            });
            window.open(routeUrl.href, '_blank');
          },
        },
      };
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: flex;
}
.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}
.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}
.left-tabs a + a {
  margin-top: 10px;
}
.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}
.right-laws {
  flex: 1;
  padding-top: 10px;
  padding-right: 20px;
}
</style>
